import DepositTabsSection from '../../sections/DepositTabsSection'
import React from 'react'
import { TabsSliceProps } from './types'

const TabsSlice: React.FC<TabsSliceProps> = ({ slice }) => {
  const { items = [] } = slice

  const data = items.map((item, index) => {
    const { tab_title = '', tab_image, content_document } = item || {}
    const {
      col_1_heading,
      col_2_heading,
      col_3_heading,
      col_4_heading,
      col_5_heading,
      col_6_heading,
      col_7_heading,
      col_8_heading,
      col_9_heading,
      col_10_heading,
      legend = [],
      rows = []
    } = content_document?.document?.data || {}

    return {
      id: `${index}`,
      tabKey: `${index}`,
      tabIcon: tab_image,
      title: tab_title,
      item: {
        data: {
          legend: legend?.map((item, index) => ({
            key: `${index}`,
            title: item?.legend_item
          })),
          list: rows.map((row) => {
            const {
              col_1_content,
              col_1_image,
              col_1_download_link,
              col_2_content,
              col_2_image,
              col_2_download_link,
              col_3_content,
              col_3_image,
              col_3_download_link,
              col_4_content,
              col_4_image,
              col_4_download_link,
              col_5_content,
              col_5_image,
              col_5_download_link,
              col_6_content,
              col_6_image,
              col_6_download_link,
              col_7_content,
              col_7_image,
              col_7_download_link,
              col_8_content,
              col_8_image,
              col_8_download_link,
              col_9_content,
              col_9_image,
              col_9_download_link,
              col_10_content,
              col_10_image,
              col_10_download_link
            } = row || {}

            const rowData: Record<string, any> = {}

            if (col_1_heading) {
              rowData[col_1_heading] = {
                title: col_1_content?.text,
                image: col_1_image?.url && col_1_image,
                download: col_1_download_link?.url && col_1_download_link
              }
            }
            if (col_2_heading) {
              rowData[col_2_heading] = {
                title: col_2_content?.text,
                image: col_2_image?.url && col_2_image,
                download: col_2_download_link?.url && col_2_download_link
              }
            }
            if (col_3_heading) {
              rowData[col_3_heading] = {
                title: col_3_content?.text,
                image: col_3_image?.url && col_3_image,
                download: col_3_download_link?.url && col_3_download_link
              }
            }
            if (col_4_heading) {
              rowData[col_4_heading] = {
                title: col_4_content?.text,
                image: col_4_image?.url && col_4_image,
                download: col_4_download_link?.url && col_4_download_link
              }
            }
            if (col_5_heading) {
              rowData[col_5_heading] = {
                title: col_5_content?.text,
                image: col_5_image?.url && col_5_image,
                download: col_5_download_link?.url && col_5_download_link
              }
            }
            if (col_6_heading) {
              rowData[col_6_heading] = {
                title: col_6_content?.text,
                image: col_6_image?.url && col_6_image,
                download: col_6_download_link?.url && col_6_download_link
              }
            }
            if (col_7_heading) {
              rowData[col_7_heading] = {
                title: col_7_content?.text,
                image: col_7_image?.url && col_7_image,
                download: col_7_download_link?.url && col_7_download_link
              }
            }
            if (col_8_heading) {
              rowData[col_8_heading] = {
                title: col_8_content?.text,
                image: col_8_image?.url && col_8_image,
                download: col_8_download_link?.url && col_8_download_link
              }
            }
            if (col_9_heading) {
              rowData[col_9_heading] = {
                title: col_9_content?.text,
                image: col_9_image?.url && col_9_image,
                download: col_9_download_link?.url && col_9_download_link
              }
            }
            if (col_10_heading) {
              rowData[col_10_heading] = {
                title: col_10_content?.text,
                image: col_10_image?.url && col_10_image,
                download: col_10_download_link?.url && col_10_download_link
              }
            }

            return rowData
          })
        }
      }
    }
  })

  return (
    <DepositTabsSection
      inner="inners.fullWidth"
      paddingTop={['24px', '0', '']}
      paddingBottom={['46px', '0', '74px']}
      headingPadding={['38px', '', '87px']}
      bgColor="grayLight"
      data={data}
    />
  )
}

export default TabsSlice
